import React, { useEffect, useState } from 'react';
import { Box, Skeleton, Typography, Button } from '@mui/material';
import { PictureAsPdf, OpenInNew } from '@mui/icons-material';
import { fetchAuthedBlobUrl, revokeBlobUrl } from '../utils/secureFile';

/**
 * <object> PDF untuk file backend ber-auth (fetch blob + cookie session).
 * Menggunakan pola yang sama dengan SecureFileImg.
 */
export default function SecureFilePdf({ src, title = 'PDF Preview', height = 500 }) {
  const [blobUrl, setBlobUrl] = useState('');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setError(false);
    setLoading(true);
    setBlobUrl('');

    if (!src) {
      setLoading(false);
      return undefined;
    }

    fetchAuthedBlobUrl(src)
      .then((url) => {
        if (!active) return;
        setBlobUrl(url);
        setLoading(false);
      })
      .catch(() => {
        if (!active) return;
        setError(true);
        setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [src]);

  if (!src) return null;

  if (error) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <PictureAsPdf sx={{ fontSize: 48, color: 'error.main', mb: 1 }} />
        <Typography variant="body2" color="error">Gagal memuat PDF</Typography>
        <Button size="small" href={src} target="_blank" sx={{ mt: 1 }} startIcon={<OpenInNew />}>
          Buka di tab baru
        </Button>
      </Box>
    );
  }

  if (loading || !blobUrl) {
    return (
      <Box sx={{ width: '100%', height }}>
        <Skeleton variant="rectangular" width="100%" height={height} />
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', height }}>
      <iframe
        src={blobUrl}
        title={title}
        width="100%"
        height={height}
        style={{ border: 'none', borderRadius: 8, background: '#fff' }}
      />
    </Box>
  );
}
